var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefreshPopupIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14431",
    "data-name": "Group 14431",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.468,
    height: 92,
    viewBox: "0 0 68.468 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5347",
    "data-name": "Rectangle 5347",
    width: 68.468,
    height: 92,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14430",
    "data-name": "Group 14430",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46420",
    "data-name": "Path 46420",
    d: "M68.468,7.564V1.486A1.486,1.486,0,0,0,66.981,0H1.486A1.486,1.486,0,0,0,0,1.486V7.564A1.486,1.486,0,0,0,1.486,9.05H5.742a30.8,30.8,0,0,0,7.392,21.46A155.531,155.531,0,0,0,27.7,45.724,155.656,155.656,0,0,0,13.134,60.939,30.837,30.837,0,0,0,5.766,82.95H1.486A1.486,1.486,0,0,0,0,84.436v6.078A1.486,1.486,0,0,0,1.486,92h65.5a1.486,1.486,0,0,0,1.487-1.486V84.436a1.486,1.486,0,0,0-1.487-1.486H63.333a30.837,30.837,0,0,0-7.369-22.011A155.551,155.551,0,0,0,41.4,45.724,155.426,155.426,0,0,0,55.964,30.51,30.8,30.8,0,0,0,63.357,9.05h3.624a1.486,1.486,0,0,0,1.487-1.486M48.96,66.671a22.873,22.873,0,0,1,4.923,9.879H15.216a22.873,22.873,0,0,1,4.923-9.879A149.7,149.7,0,0,1,34.55,51.731,149.454,149.454,0,0,1,48.96,66.671m1.8-44.362H18.338A21.363,21.363,0,0,1,14.8,9.05H54.3A21.363,21.363,0,0,1,50.76,22.309",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46421",
    "data-name": "Path 46421",
    d: "M40.557,62.867a1.778,1.778,0,1,1-1.778-1.778,1.778,1.778,0,0,1,1.778,1.778",
    transform: "translate(-4.1 -6.769)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46422",
    "data-name": "Path 46422",
    d: "M40.557,68.867a1.778,1.778,0,1,1-1.778-1.778,1.778,1.778,0,0,1,1.778,1.778",
    transform: "translate(-4.1 -7.434)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46423",
    "data-name": "Path 46423",
    d: "M40.557,74.867a1.778,1.778,0,1,1-1.778-1.778,1.778,1.778,0,0,1,1.778,1.778",
    transform: "translate(-4.1 -8.099)",
    fill: "#2c3c46"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshPopupIcon);
export default __webpack_public_path__ + "static/media/refresh-popup-icon.59e70c6127701b0cf73a8bc484a60f6e.svg";
export { ForwardRef as ReactComponent };